module.exports = __webpack_public_path__ + "img/06.0ad9a684.png";